module.exports = "<h1>{{ 'MANAGEMENT.NAVIGATION.administrators-label' | translate }}</h1>\r\n"